export const ROUTES = {
  BASE: '/',
  APARTMENTS: '/stanovi',
  ADVANTAGES: '/prednosti',
  LOCATION: '/lokacija',
  DESCRIPTION: '/opis',
  CONTACT: '/kontakt',
  THANK_YOU: '/hvala-vam',
};
